import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-contact',
  templateUrl: './about-contact.component.html',
  styleUrls: ['./about-contact.component.css']
})
export class AboutContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
